var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ls-out-of-market__container"},[_c('OutOfMarketLeadspediaForm')],1)}
var staticRenderFns = []

export { render, staticRenderFns }